import { Suspense, lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
const VotersList = lazy(() => import('src/sections/voters/voters-list'));
const VoterSearch = lazy(() => import('src/sections/voters/search'));
const VotersView = lazy(() => import('src/sections/voters/voters-view'));

export const voterRoutes = (tenantTerminology) => [
  {
    path: tenantTerminology?.voters,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      // The section root and any old link to it land on the search; classic has its own path.
      { element: <Navigate to="search" replace />, index: true },
      // The rebuilt search screen — open to everyone since 2026-08-18 (the pilot gate is gone).
      // Its own route rather than a toggle on the index: the screen serializes its filters into the
      // query string, so the path is what makes a shared link unambiguous about which experience it
      // should open. One segment, so it can't collide with the two-segment ':state/:id' sibling.
      {
        path: 'search',
        element: <VoterSearch />,
      },
      // The classic list, reached only through the search screen's "Use the classic search
      // instead" button. One segment, like 'search', so it can't collide with ':state/:id'.
      {
        path: 'classic',
        element: <VotersList />,
      },
      {
        path: ':state/:id',
        element: <VotersView />,
      },
    ],
  },
];
